import { render, staticRenderFns } from "./purchaseCheckAction.vue?vue&type=template&id=cd23353e&scoped=true"
import script from "./purchaseCheckAction.vue?vue&type=script&lang=js"
export * from "./purchaseCheckAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseCheckAction.vue?vue&type=style&index=0&id=cd23353e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd23353e",
  null
  
)

export default component.exports